import Service from '../../services'

// initial state
const state = {
  footer: {
    logo_opm_url: '',
    logo_site_url: '',
    creative_economy_review_url: '',
    data_and_statistics_url: '',
    research_and_report_url: '',
    c_index_url: '',
    about_url: '',
    address_th: '',
    address_en: '',
    tel: '',
    fax: '',
    email: '',
    fb_url: '',
    fb_title_th: '',
    fb_title_en: '',
  }
}

// getters
const getters = {}

// actions
const actions = {
  async populateFooter({ commit }) {
    const footer = await Service.site.getFooter()
    commit('setFooter', footer)
    return footer
  },

  async updateFooter({ commit, state }) {
    const footer = await Service.site.updateFooter(state.footer)
    commit('setFooter', footer)
    return footer
  }
}

// mutations
const mutations = {
  setFooter(state, data) {
    state.footer = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
